import React from 'react'

class NotFound extends React.Component {
	render() {
		return (
			<section className="container">
				<h2>Oops!</h2>
				<h3>We can't find the page you're looking for.  Please check the URL and try again.</h3>
			</section>
		)
	}
}

export default NotFound


// WEBPACK FOOTER //
// ./src/pages/notfound.js